import React from 'react';
import { connect } from 'react-redux';

//
//Component for creating expirable objects.
//
//To use, write the object or component you want to expire
//in :delay: time by <Expire delay={:delay:}> your_object </Expire>
//
class Expire extends React.Component {
    
    constructor(props, context) {
        super(props, context);
        
        this.state = {
            visible: true,
            delay: props.delay
        }
    }
     
    componentWillReceiveProps = (nextProps) => {
        // reset the timer if children are changed
        if (nextProps.children !== this.props.children) {
            this._setTimer();
            this.setState({visible: true});
        }
    }
    
    componentDidMount = () => {
        this._setTimer();
    }
    
    _setTimer = () => {
        // clear any existing timer
        this._timer != null ? clearTimeout(this._timer) : null;

        // hide after `delay` milliseconds
        this._timer = setTimeout(function(){
            this.setState({visible: false});
            this._timer = null;
        }.bind(this), this.props.delay);
    }
    
    componentWillUnmount = () => {
        clearTimeout(this._timer);
    }

    render = () => {
        return this.state.visible ? <div>{this.props.children}</div> : <span />;
    }
}

export default connect()(Expire);



/** WEBPACK FOOTER **
 ** ./src/app/components/Expire.js
 **/